import { useState, useEffect } from "react";
import  axiosService from "../../utils/axios.service";
import { formatValue } from 'react-currency-input-field';
import { format } from 'date-fns'
import { notifications } from "../constant/Notify";
import { Spin } from 'antd';

export function TransactionList(props) {
    const [dataTransaction, setDataTransaction] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(async () => {
        fetchData()
    }, [])

    const fetchData = async () => {
        let response = await axiosService("api/transaction/order/" + props.orderDetail.id, "GET");
        if (response.data.code == 200) {            
            setDataTransaction(response.data.data)
            setLoading(false)
        }
    }

    const actionMisa = async (type, idTransaction, idOrder) => {
        if (!loading) {
            setLoading(true)
            let url = "api/get-order-id-misa"
            let payload = {
                order_id: idOrder,
                transaction_id: idTransaction
            }
            if (type === 2) url = "api/create-misa-by-transaction"
            
            const res = await axiosService(url, "POST", payload)
            if (res.data.success) {
                fetchData()
                notifications({ type: 'success', mess: 'Cập nhật thành công' });
            } else {
                notifications({ type: 'error', mess: res.data.message ?? 'Cập nhật thất bại' });
                setLoading(false)
            }
        }
    }
    return (
        <div className="transaction-history-popup">
            <div className="head-popup">
                <div className="title">Lịch sử thanh toán</div>
            </div>
            <Spin spinning={loading} size="large" tip="Đang cập nhật">
                <div className="body-popup">
                    <table className="table">
                        <thead className="hide-mobile">
                            <tr>
                                <th className="text-center">Ngày thanh toán</th>
                                <th className="text-center">Trạng thái</th>
                                <th className="text-center">Số tiền</th>
                                <th className="text-center">Loại tiền</th>
                                <th className="text-center">Tài khoản</th>
                                <th className="text-center">Thu ngân</th>
                                <th className="text-center">Cơ sở</th>
                                <th className="text-right">ID Misa</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataTransaction.length > 0 ? 
                                dataTransaction.map((val, key) => (
                                    <tr key={key} className="item-mobile-table">
                                        <td className="text-center mobile-table">
                                            <div className="title hide-desktop">Ngày thanh toán</div>
                                            <div className="value">
                                                {val.transaction_code} <br />
                                                {format(new Date(val.transaction_at), "dd-MM-yyyy HH:mm:ss")}
                                            </div>
                                        </td>
                                        <td className="text-center mobile-table">
                                            <div className="title hide-desktop">Trạng thái</div>
                                            <div className="value">{val.status == 1 ? "Thanh toán" : val.status == 2 ? "Trả nợ" : "Hoàn tiền"}</div>
                                        </td>
                                        <td className="text-center mobile-table">
                                            <div className="title hide-desktop">Số tiền</div>
                                            <div className="value">
                                                <span className="cash-vnd">
                                                    {val.paid_amount? formatValue({ value: String(val.paid_amount), groupSeparator: ',', decimalSeparator: '.', }) : '0'} đ
                                                </span>
                                            </div>
                                        </td>
                                        <td className="text-center mobile-table">
                                            <div className="title hide-desktop">Loại tiền</div>
                                            <div className="value">{val.pay_type}</div>
                                        </td>
                                        <td className="text-center mobile-table">
                                            <div className="title hide-desktop">Tài khoản</div>
                                            {val.banking ?
                                                <div className="value">{val.banking[0]} <br/> {val.banking[2]}</div>
                                            :
                                                <div className="value">- -</div>
                                            }
                                        </td>
                                        <td className="text-center mobile-table">
                                            <div className="title hide-desktop">Thu ngân</div>
                                            <div className="value">{val.user?.name ?? ""}</div>
                                        </td>
                                        <td className="text-center mobile-table">
                                            <div className="title hide-desktop">Cơ sở</div>
                                            <div className="value">{val?.store?.name_store ?? ""}</div>
                                        </td>
                                        <td className="text-right mobile-table">
                                            <div className="title hide-desktop">ID Misa</div>
                                                <div className="value">
                                                    {val.misa_no ? 
                                                        val.misa_no 
                                                    :
                                                        val.sync_misa >= 0 ? 
                                                            val.sync_misa >= 1 ? 
                                                                <button className={`btn btn-xs bg-danger-400 mr-5 action-misa`} onClick={() => actionMisa(val.sync_misa, val.id, val.order.id)}>
                                                                    <i className="fas fa-sync-alt"></i>
                                                                </button>
                                                            : "Không xuất HĐ"
                                                        :null
                                                    }
                                                </div>
                                        </td>
                                    </tr>
                                ))
                            : <tr></tr>}
                        </tbody>
                    </table>
                </div>
            </Spin>
        </div>
    )
}